import React, { useState, createContext, useContext } from 'react';
interface BookingContextType {
  isOpen: boolean;
  openBooking: () => void;
  closeBooking: () => void;
}
const BookingContext = createContext<BookingContextType>({
  isOpen: false,
  openBooking: () => {},
  closeBooking: () => {}
});
export function useBooking() {
  return useContext(BookingContext);
}
export function BookingProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <BookingContext.Provider value={{
    isOpen,
    openBooking: () => setIsOpen(true),
    closeBooking: () => setIsOpen(false)
  }} data-id="element-135">
      {children}
    </BookingContext.Provider>;
}